import React__default from 'react';
import createSvgIcon from '../utils/createSvgIcon.js';
import '../SvgIcon-0b8a779c.js';
import 'classnames';

var Close = createSvgIcon(React__default.createElement("path", { d: "M13.4142 12L20.7071 4.70709L19.2928 3.29288L12 10.5858L4.70706 3.29288L3.29285 4.70709L10.5857 12L3.29285 19.2929L4.70706 20.7071L12 13.4142L19.2928 20.7071L20.7071 19.2929L13.4142 12Z" }), 'Close');

export { Close };
